/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService
 */
import * as References from './PurchaseMotionsEvaluationService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService#evaluateInApp
 */
export const EVALUATE_IN_APP_QUERY_FIELD_NAME = 'com_hubspot_purchase_motions_rpc_PurchaseMotionsEvaluationService_evaluateInApp';
export const EVALUATE_IN_APP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: EVALUATE_IN_APP_QUERY_FIELD_NAME,
  args: ['productApiNames', 'locations', 'purchaseMotionFilterParameters', 'productQuantities'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.evaluateInAppRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService#getSelfServiceEligibility
 */
export const GET_SELF_SERVICE_ELIGIBILITY_QUERY_FIELD_NAME = 'com_hubspot_purchase_motions_rpc_PurchaseMotionsEvaluationService_getSelfServiceEligibility';
export const GET_SELF_SERVICE_ELIGIBILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SELF_SERVICE_ELIGIBILITY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSelfServiceEligibilityRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});